<template>
	<div class="image-preview-modal">
		<div class="image-name">{{ name }}</div>
		<div class="image-body">
			<img :src="image" :style="style" />
		</div>

		<b-button type="is-primary" rounded :loading="isOkButtonLoading" @click="onOkClick">{{ okButtonTitle }}</b-button>
	</div>
</template>

<script>

export default {
	name: 'ImagePreviewModal',
	props: {
		name: {
			type: String,
			default: '',
		},
		image: {
			type: String,
			default: '',
		},
		okButtonTitle: {
			type: String,
			default: 'OK',
		},
		isOkButtonLoading: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
		}
	},
	mounted() {
	},
	computed: {
		style: function() {
			let style = {
				
				'max-height': this.maxH + 'px',
				'margin': '0 auto',
			};

			return style;
		},
	},
	methods: {
		onOkClick: function() {
			this.$emit('ok-click');
		},
	},
}
</script>

<style lang="scss">

</style>
